import React from 'react';
import { Div } from 'Common/components/Atoms/Div';
import { Text } from 'Common/components/Atoms/Text';
import h1BlackLogo from 'resources/hackerone_logo_black.png';
import h1WhiteLogo from 'resources/hackerone_logo_white.png';
import primaryLogo from 'resources/full-logo.svg';
import secondaryLogo from 'resources/secondary-logo.svg';
import { useTheme } from '@mui/material';

const SecurityLogo = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  return (
    <Div display="flex">
      <Div
        width={126}
        height={30}
        background={`url(${
          isDarkMode ? h1WhiteLogo : h1BlackLogo
        }) 0% 0% / contain no-repeat`}
        flexGrow={0}
      />
      <Text fontSize={16} pl={0.75} pr={1} mt={0.75}>
        by
      </Text>
      <Div
        mt={0.75}
        width={95}
        height={22}
        background={`url(${
          isDarkMode ? secondaryLogo : primaryLogo
        }) 0% 0% / contain no-repeat`}
      />
    </Div>
  );
};

export default SecurityLogo;
